import { HistoricalType } from "@customTypes/responses/lawsuit";

export const hiddenTitlesByType: HistoricalType[] = ["AUTOMATIC_LAWSUIT", "CLIPPING"];
